import {
  IdentificationFormStepNames,
  StepStatus,
  TAddress,
  TFormAddress,
  TPersonalDocument,
} from './types';
import GettingStartedIcon from '~/assets/icons/sidebar/GettingStartedIcon.svg?react';
import GeneralInfoIcon from '~/assets/icons/sidebar/GeneralInfoIcon.svg?react';
import FinancialStatusIcon from '~/assets/icons/sidebar/FinancialStatusIcon.svg?react';
import BusinessRelationsIcon from '~/assets/icons/sidebar/BusinessRelationsIcon.svg?react';
import DocumentsIcon from '~/assets/icons/sidebar/DocumentsIcon.svg?react';
import RelatedCompaniesIcon from '~/assets/icons/sidebar/RelatedCompaniesIcon.svg?react';
import ManagementStructureIcon from '~/assets/icons/sidebar/ManagementStructureIcon.svg?react';
import ManagersAndRepresentativesIcon from '~/assets/icons/sidebar/ManagersAndRepresentativesIcon.svg?react';
import OwnershipStructureIcon from '~/assets/icons/sidebar/OwnershipStructureIcon.svg?react';
import AdditionalInfoIcon from '~/assets/icons/sidebar/AdditionalInfoIcon.svg?react';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';
import { UKRAINE_CODE } from '~/constants/common.ts';
import { EMPTY_OPTION } from '~/components/FormComponents/constants';

export const gettingStartedStep = {
  name: IdentificationFormStepNames.gettingStarted,
  icon: GettingStartedIcon,
  sidebarTitle: 'Початок роботи',
  pageTitle: 'Початок роботи',
  stepStatus: StepStatus.passive,
};
export const generalInfoStep = {
  name: IdentificationFormStepNames.generalInfo,
  icon: GeneralInfoIcon,
  sidebarTitle: 'Загальна інформація',
  pageTitle: 'Загальна інформація',
  stepStatus: StepStatus.disabled,
};
export const financialStateStep = {
  name: IdentificationFormStepNames.financialState,
  icon: FinancialStatusIcon,
  sidebarTitle: 'Фінансовий стан',
  pageTitle: 'Фінансовий стан',
  stepStatus: StepStatus.disabled,
};
export const purposeOfBusinessRelationsStep = {
  name: IdentificationFormStepNames.purposeOfBusinessRelations,
  icon: BusinessRelationsIcon,
  sidebarTitle: 'Мета і характер ділових відносин',
  pageTitle: 'Мета і характер ділових відносин',
  stepStatus: StepStatus.disabled,
};
export const documentsStep = {
  name: IdentificationFormStepNames.documents,
  icon: DocumentsIcon,
  sidebarTitle: 'Документи',
  pageTitle: 'Документи',
  stepStatus: StepStatus.disabled,
};
export const additionalInformationStep = {
  name: IdentificationFormStepNames.additionalInformation,
  icon: AdditionalInfoIcon,
  sidebarTitle: 'Додаткова інформація (PEP)',
  pageTitle: 'Додаткова інформація (PEP)',
  stepStatus: StepStatus.disabled,
};
export const taxResidencyAdditionalInformationStep = {
  name: IdentificationFormStepNames.taxResidencyAdditionalInformation,
  icon: AdditionalInfoIcon,
  sidebarTitle: 'Додаткова інформація (CRS)',
  pageTitle: 'Додаткова інформація (CRS)',
  stepStatus: StepStatus.disabled,
};
export const fatcaAdditionalInformationStep = {
  name: IdentificationFormStepNames.fatcaAdditionalInformation,
  icon: AdditionalInfoIcon,
  sidebarTitle: 'Додаткова інформація (FATCA)',
  pageTitle: 'Додаткова інформація (FATCA)',
  stepStatus: StepStatus.disabled,
};
export const relatedCompaniesStep = {
  name: IdentificationFormStepNames.relatedCompanies,
  icon: RelatedCompaniesIcon,
  sidebarTitle: 'Пов’язані компанії',
  pageTitle: 'Пов’язані компанії',
  stepStatus: StepStatus.disabled,
};
export const managementStructureStep = {
  name: IdentificationFormStepNames.managementStructure,
  icon: ManagementStructureIcon,
  sidebarTitle: 'Структура управління',
  pageTitle: 'Структура управління',
  stepStatus: StepStatus.disabled,
};
export const managersAndRepresentativesStep = {
  name: IdentificationFormStepNames.managersAndRepresentatives,
  icon: ManagersAndRepresentativesIcon,
  sidebarTitle: 'Розпорядники та представники',
  pageTitle: 'Розпорядники та представники',
  stepStatus: StepStatus.disabled,
};
export const ownershipStructureStep = {
  name: IdentificationFormStepNames.ownershipStructure,
  icon: OwnershipStructureIcon,
  sidebarTitle: 'Структура власності',
  pageTitle: 'Структура власності',
  stepStatus: StepStatus.disabled,
};

export const identificationFormSteps = {
  gettingStartedStep,
  generalInfoStep,
  ownershipStructureStep,
  managersAndRepresentativesStep,
  managementStructureStep,
  relatedCompaniesStep,
  taxResidencyAdditionalInformationStep,
  additionalInformationStep,
  documentsStep,
  purposeOfBusinessRelationsStep,
  financialStateStep,
} as const;

export const WEB_FORMS_NAME: Record<string, string> = {
  GETTING_STARTED: 'Початок роботи',
  GENERAL_INFO: 'Загальна інформація',
  MANAGEMENT_STRUCTURE: 'Структура управління',
  FINANCIAL_STATE: 'Фінансовий стан',
  PURPOSE_BUSINESS_RELATIONS: 'Мета і характер ділових відносин',
  DOCUMENTS: 'Документи',
  ADDITIONAL_INFO: 'Додаткова інформація (PEP)',
  ASSET_MANAGERS_AND_REPRESENTATIVES: 'Розпорядники та представники',
  RELATED_COMPANIES: 'Пов’язані компанії',
  OWNERSHIP_STRUCTURE: 'Структура власності',
  GENERAL_INFO_ASSET_MANAGERS: 'Загальна інформація розпорядники',
  TAX_RESIDENCY_ADDITIONAL_INFO: 'Додаткова інформація (CRS)',
  FATCA_ADDITIONAL_INFORMATION: 'Додаткова інформація (FATCA)',
};

export const ukraineOption: TAutocompleteOption = {
  value: UKRAINE_CODE,
  label: 'Україна',
};

export const emptySelectItem: TAutocompleteOption = { label: '', value: '-1' };

export const defaultAddress: TFormAddress = {
  address: null,
  country: ukraineOption,
  postalCode: null,
  region: EMPTY_OPTION,
  district: EMPTY_OPTION,
  city: EMPTY_OPTION,
  street: EMPTY_OPTION,
  houseNumber: null,
  building: null,
  apartment: null,
  codeAddress: null,
};

export const defaultFormAddress: TAddress = {
  registrationAddress: defaultAddress,
  permanentAddress: defaultAddress,
  coincidences: false,
};

export const emptyPersonalDocumentInfo: TPersonalDocument = {
  documentType: null,
  documentNumber: null,
  documentSeries: null,
  registryRecord: null,
  issueDate: null,
  documentExpiryDate: null,
  issuingAuthority: null,
};

export const signatureAuthorityDetailsOptions = [
  { value: '1', label: 'Перший підпис' },
  { value: '2', label: 'Другий підпис' },
];

export const verificationStatusDisplayNameMapping = {
  IN_PROGRESS: 'Очікує верифікації',
  COMPLETED: 'Верифікація пройдена',
  UPDATE_REQUESTED: 'Очікує оновлення даних',
};
export const EMPTY_LICENSE = {
  licenseName: '',
  licenseDate: '',
  licenseNumber: '',
  licenseOrganisationCreate: '',
  licenseExpiryTerm: null,
};

export const LICENSE_ROW_HEIGHT = 78;
export const LICENSE_HEDER_HEIGHT = 34;
export const LICENSE_MOBILE_BUTTONS_HEIGHT = 40;
export const licenseTableColumns = [
  {
    title: 'Найменування ліцензії',
    size: 3,
  },
  {
    title: 'Дата видачі',
    size: 2,
  },
  {
    title: 'Номер ліцензії',
    size: 2,
  },
  {
    title: 'Ким видана ліцензія',
    size: 2,
  },
  {
    title: 'Термін дії ліцензії',
    size: 2,
  },
];

export const updatingDataFop = [
  { value: '1', label: 'Зміни ідентифікаційних даних/ документу(в тому числі на ID карти) ФОП' },
  { value: '2', label: 'Встановлення належності клієнта (КБВ клієнта) до РЕР' },
  { value: '3', label: 'Місцезнаходження (за винятком Декомунізація)' },
];

export const updatingDataLegalResident = [
  { value: '1', label: 'Зміни КБВ клієнта' },
  { value: '2', label: 'Встановлення належності клієнта (КБВ клієнта) до РЕР' },
  { value: '3', label: 'Змін в статутних документах/нових редакцій статутних документів' },
  { value: '4', label: 'Місцезнаходження (за винятком Декомунізація)' },
  { value: '5', label: 'Форми власності/організаційно-правової форми' },
  { value: '6', label: 'Зміни назви' },
];

export const informationAboutLegislation = [
  `      Цим підтверджую, що ознайомлений з тим, що виконання Закону України "Про
                  запобігання та протидію легалізації (відмиванню) доходів, одержаних злочинним
                  шляхом, фінансуванню тероризму та фінансуванню розповсюдження зброї масового
                  знищення" (далі – Закон) не є порушенням Закону України «Про захист персональних
                  даних" в частині обробки персональних даних.`,
  `      Обробка персональних даних відповідно до вимог Закону здійснюється без отримання
                  необхідності згоди суб'єкта персональних даних. АТ «Укрексімбанк» (як суб'єкт
                  первинного фінансового моніторингу) повідомив про покладений на нього обов'язок з
                  обробки персональних даних для цілей запобігання та протидії легалізації
                  (відмиванню) доходів, одержаних злочинним шляхом, фінансуванню тероризму та
                  фінансуванню розповсюдження зброї масового знищення.`,
  `      Також підтверджую, що фізичні особи, відомості стосовно яких надаватимуться,
                  повідомлені про АТ "Укрексімбанк" як володільця відповідних персональних даних,
                  склад та зміст зібраних персональних даних, їх права, визначені Законом України
                  "Про захист персональних даних" та мету збору персональних даних.`,
];
